import { z } from "zod/v4";

export const OrgIdNameDtoSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  shopId: z.string(),
  orderCount: z.number().optional(),
});

export type OrgIdNameDto = z.infer<typeof OrgIdNameDtoSchema>;
